export interface TrendItem {
  id: number;
  rank: number;
  tag: string;
  title: string;
  heat: string;
  status: string;
  change: "up" | "down" | "flat" | "new";
}

export interface Category {
  key: string;
  name: string;
  icon: string;
  desc: string;
}

export interface TimeNode {
  time: string;
  title: string;
  detail: string;
  kind: string;
}

export interface EventItem {
  id: number;
  category: string;
  title: string;
  brief: string;
  date: string;
  readTime: string;
  comments: string;
  status: string;
  highlight: boolean;
  nodes: TimeNode[];
}

export interface Faq {
  q: string;
  a: string;
}

export const categories: Category[] = [
  { key: "all", name: "全部", icon: "ri-fire-line", desc: "所有正在发酵的热点事件" },
  { key: "ent", name: "娱乐圈", icon: "ri-star-smile-line", desc: "明星动态与作品话题" },
  { key: "sports", name: "体育圈", icon: "ri-trophy-line", desc: "赛场内外的是与非" },
  { key: "internet", name: "互联网", icon: "ri-computer-line", desc: "大厂动态与行业争议" },
  { key: "society", name: "社会民生", icon: "ri-building-2-line", desc: "身边的真实故事" },
  { key: "business", name: "商业财经", icon: "ri-line-chart-line", desc: "资本场里的分分合合" },
];

export const hotTrends: TrendItem[] = [
  { id: 1, rank: 1, tag: "娱乐圈", title: "国民剧《暗夜尽头》杀青风波引热议，片方深夜回应", heat: "342.6万", status: "有新进展", change: "up" },
  { id: 2, rank: 2, tag: "互联网", title: "某社交平台上线新功能，用户连夜吐槽界面太挤", heat: "298.1万", status: "发酵中", change: "up" },
  { id: 3, rank: 3, tag: "社会民生", title: "一线城市地铁晚高峰新规，通勤族吵翻了", heat: "267.9万", status: "发酵中", change: "new" },
  { id: 4, rank: 4, tag: "体育圈", title: "季前赛爆冷背后：核心球员去留传闻又反转", heat: "231.4万", status: "已反转", change: "flat" },
  { id: 5, rank: 5, tag: "商业财经", title: "老牌茶饮联名翻车，被吐槽「割韭菜」", heat: "198.7万", status: "已反转", change: "down" },
  { id: 6, rank: 6, tag: "娱乐圈", title: "综艺《奔跑吧晚班车》新一季阵容官宣引猜测", heat: "176.3万", status: "有新进展", change: "up" },
  { id: 7, rank: 7, tag: "社会民生", title: "夜市摆摊文化爆红，年轻人涌入地摊经济", heat: "155.8万", status: "发酵中", change: "flat" },
  { id: 8, rank: 8, tag: "互联网", title: "国产大模型再出圈，演示视频刷屏朋友圈", heat: "143.2万", status: "有新进展", change: "up" },
];

export const events: EventItem[] = [
  {
    id: 1,
    category: "ent",
    title: "国民剧《暗夜尽头》杀青风波全记录",
    brief: "从一张路透照到全员离组，再到片方深夜声明，这部剧的杀青风波成了本周最热闹的瓜。",
    date: "2026-09-05",
    readTime: "6 分钟",
    comments: "3.2万",
    status: "有新进展",
    highlight: true,
    nodes: [
      { time: "08-28 22:15", title: "路透照流出", detail: "有现场网友晒出一张模糊路透照，画面里几位主要演员表情严肃，配文称「片场气氛不对劲」，当晚相关话题冲上热搜前二十。", kind: "开始" },
      { time: "08-30 10:40", title: "换角传闻发酵", detail: "多个娱乐博主接力爆料，称剧组某配角因档期问题将退出，主角档期亦受影响，进组时间一再推迟，评论区开始分成两派吵起来。", kind: "发酵" },
      { time: "09-01 18:20", title: "全员暂缓拍摄", detail: "有工作人员匿名透露「暂缓拍摄」，网络上关于「停拍」的猜测达到顶峰，多档宣传物料被临时撤下，粉丝开始集中讨论。", kind: "高潮" },
      { time: "09-03 23:50", title: "片方深夜回应", detail: "出品方发布长文说明，澄清并非停拍，而是因场地档期调整作出拍摄计划微调，并点名感谢了坚守现场的主创团队。", kind: "反转" },
      { time: "09-05 12:30", title: "复工照曝光", detail: "官微晒出剧组最新开工照，多位主演现身，此前讨论热度明显回落，新一轮口碑分化却悄然开启。", kind: "进展" },
    ],
  },
  {
    id: 2,
    category: "sports",
    title: "季前赛爆冷背后的去留疑云",
    brief: "一场不被看好的季前赛掀翻夺冠热门，赛后核心球员的离队传闻却在三天内两度反转。",
    date: "2026-09-04",
    readTime: "5 分钟",
    comments: "1.8万",
    status: "已反转",
    highlight: true,
    nodes: [
      { time: "09-01 20:00", title: "季前赛爆冷", detail: "排名靠后的队伍客场掀翻夺冠热门，赛后采访中输球方主帅的一句「阵容会有变化」被反复解读。", kind: "开始" },
      { time: "09-02 09:10", title: "离队传闻出现", detail: "某体育媒体爆料核心球员已与管理层谈崩，即将进入交易市场，球迷瞬间炸锅，讨论量一路走高。", kind: "发酵" },
      { time: "09-02 21:45", title: "球员本人下场", detail: "当事人在个人社交平台晒出训练照并配文「别急着送人走」，被普遍视为否认离队的信号。", kind: "反转" },
      { time: "09-03 15:30", title: "官方口径更新", detail: "俱乐部发布公告确认球员续约谈判仍在进行中，但未排除交易可能，悬念留到开赛日。", kind: "进展" },
    ],
  },
  {
    id: 3,
    category: "business",
    title: "老牌茶饮联名「割韭菜」争议始末",
    brief: "一次看似双赢的联名，因定价与物料问题翻了车，品牌连夜致歉并调整方案。",
    date: "2026-09-03",
    readTime: "4 分钟",
    comments: "9.6千",
    status: "已反转",
    highlight: false,
    nodes: [
      { time: "08-30 10:00", title: "联名官宣", detail: "老牌茶饮与某动漫 IP 官宣联名，预告片中主角形象让期待值拉满，预约人数破纪录。", kind: "开始" },
      { time: "08-31 14:20", title: "定价引争议", detail: "联名套餐定价公布后，网友对比发现容量缩水、价格上浮，大量「为了周边」的讨论开始发酵。", kind: "发酵" },
      { time: "09-01 11:00", title: "被质疑割韭菜", detail: "多个测评博主拆解联名物料成本，指出周边做工粗糙，吐槽声浪达到顶点，话题冲上热榜。", kind: "高潮" },
      { time: "09-02 19:10", title: "品牌致歉调整", detail: "品牌方发声明致歉，承诺加量不加价并升级周边材质，部分门店连夜更换新版物料。", kind: "反转" },
    ],
  },
  {
    id: 4,
    category: "ent",
    title: "《奔跑吧晚班车》阵容官宣全脉络",
    brief: "从「全员回归」的预告，到两位常驻缺席的猜测，再到正式名单，吃瓜群众全程紧盯。",
    date: "2026-09-02",
    readTime: "5 分钟",
    comments: "2.5万",
    status: "有新进展",
    highlight: false,
    nodes: [
      { time: "08-29 19:00", title: "海报预告", detail: "节目组发布剪影海报，配文「全员回归」，粉丝开始逐帧比对哪位是常驻。", kind: "开始" },
      { time: "08-30 16:30", title: "缺席猜测", detail: "细心的网友发现海报少了一到两个轮廓，关于某常驻是否离开的猜测迅速发酵。", kind: "发酵" },
      { time: "08-31 12:00", title: "官微暗示", detail: "官方连发两条暗示性博文，评论区上演「列文虎克式」解析，热度再创新高。", kind: "高潮" },
      { time: "09-02 10:00", title: "正式官宣", detail: "完整阵容公布，两位新面孔加入，旧人虽缺席但官微送上祝福，讨论回归理性。", kind: "进展" },
    ],
  },
  {
    id: 5,
    category: "society",
    title: "夜市摆摊文化爆红记",
    brief: "从城市管理的两难，到年轻人涌入地摊经济，这场关于烟火气的讨论还在持续。",
    date: "2026-09-01",
    readTime: "6 分钟",
    comments: "4.1万",
    status: "发酵中",
    highlight: false,
    nodes: [
      { time: "08-25 20:00", title: "短视频出圈", detail: "一段「00 后夜校下班摆摊」的视频爆火，播放量破千万，摆摊话题第一次进入大众视野。", kind: "开始" },
      { time: "08-27 12:00", title: "管理话题升温", detail: "部分城市出台地摊规范，摊主与周边商户的矛盾被摆上台面，评论区两极分化。", kind: "发酵" },
      { time: "08-29 09:30", title: "官方回应", detail: "多地城管部门就摊点规划作出回应，表示将「疏堵结合」，并公布试点街区名单。", kind: "进展" },
      { time: "09-01 15:00", title: "年轻人涌入", detail: "白领下班摆摊成为新流行，夜市经济相关词条连续多日霸榜，讨论仍在继续。", kind: "高潮" },
    ],
  },
  {
    id: 6,
    category: "internet",
    title: "某社交平台新功能上线风波",
    brief: "一次界面更新，为何让用户集体不适？从吐槽到改版，平台只用了三天。",
    date: "2026-08-31",
    readTime: "4 分钟",
    comments: "1.2万",
    status: "已结束",
    highlight: false,
    nodes: [
      { time: "08-28 10:30", title: "灰度上线", detail: "平台向部分用户灰度推送新版界面，信息流变拥挤、按钮变小，截图开始流传。", kind: "开始" },
      { time: "08-28 22:00", title: "集体吐槽", detail: "大量用户晒出新旧对比图，抱怨「像贴满广告的老年机」，话题登上热榜第一。", kind: "发酵" },
      { time: "08-29 17:40", title: "官方回应", detail: "产品团队发文致歉，解释新功能是为满足「更多内容展示」需求，但承认交互体验考虑不周。", kind: "进展" },
      { time: "08-31 11:20", title: "回滚处理", detail: "平台宣布已回滚至旧界面并保留用户反馈入口，风波基本平息。", kind: "尾声" },
    ],
  },
  {
    id: 7,
    category: "business",
    title: "国产大模型演示视频出圈记",
    brief: "一段演示如何撬动全网关注，也让行业里「真假性能」的争论再次被点燃。",
    date: "2026-08-30",
    readTime: "5 分钟",
    comments: "8.8千",
    status: "有新进展",
    highlight: false,
    nodes: [
      { time: "08-26 15:00", title: "演示视频发布", detail: "某公司发布新一代大模型演示，实时推理与多模态能力让开发者直呼「很顶」，视频刷屏。", kind: "开始" },
      { time: "08-27 10:00", title: "技术质疑出现", detail: "有研究者指出演示中可能存在「预先准备」，真假性能之争在技术圈内激烈展开。", kind: "发酵" },
      { time: "08-28 14:30", title: "官方开放内测", detail: "官方宣布开放限量内测回应质疑，申请入口一度被挤爆，实测反馈两极。", kind: "进展" },
      { time: "08-30 20:00", title: "头部公司跟进", detail: "同赛道多厂陆续官宣新进展，行业「军备竞赛」话题被推向高峰。", kind: "高潮" },
    ],
  },
  {
    id: 8,
    category: "society",
    title: "一线城市地铁晚高峰新规之争",
    brief: "为缓解拥堵而设的新规，为何让通勤族吵翻天？一次出行规则调整背后的真实权衡。",
    date: "2026-08-29",
    readTime: "5 分钟",
    comments: "3.0万",
    status: "发酵中",
    highlight: false,
    nodes: [
      { time: "08-27 08:00", title: "新规上线", detail: "部分站点实行分时段限流新规，早高峰排队时间明显变长，赶时间的上班族最先发声。", kind: "开始" },
      { time: "08-27 19:00", title: "两极观点交锋", detail: "有人认为「保安全应该支持」，有人抱怨「绕路加排队到崩溃」，相关话题阅读量破亿。", kind: "发酵" },
      { time: "08-28 22:00", title: "运营方说明", detail: "地铁官方就新规作出说明，解释是为应对节假日客流叠加，并公布了动态调整预案。", kind: "进展" },
      { time: "08-29 12:00", title: "讨论持续升温", detail: "通勤数据、站外排队实况等实测内容不断流出，关于「更优解」的讨论仍在发酵。", kind: "高潮" },
    ],
  },
  {
    id: 9,
    category: "ent",
    title: "新生代演员「考古」翻红现象",
    brief: "一段五年前的冷门片段突然被翻出，让一位年轻演员重回大众视野，背后是观众的集体怀旧。",
    date: "2026-08-28",
    readTime: "4 分钟",
    comments: "1.5万",
    status: "已结束",
    highlight: false,
    nodes: [
      { time: "08-22 21:00", title: "冷门片段翻红", detail: "网友晒出五年前的片场花絮，演员的敬业细节被反复搬运，播放量节节攀升。", kind: "开始" },
      { time: "08-23 20:00", title: "全网考古", detail: "其早年作品、采访被逐一考古，话题从「演技」延展到「被低估的演员」，讨论走向多元。", kind: "发酵" },
      { time: "08-25 12:00", title: "本人回应", detail: "当事人在直播中回应考古热，感谢观众支持并透露新作品计划，热度再度攀升。", kind: "进展" },
      { time: "08-28 10:00", title: "热度回落", detail: "随着新话题出现，该事件讨论回归常态，成为新一轮「口碑型翻红」的典型案例。", kind: "尾声" },
    ],
  },
  {
    id: 10,
    category: "sports",
    title: "电竞战队选手转会连环瓜",
    brief: "从「被挂牌」到「留队」，再到新东家官宣，一场转会尘埃落定，悬念十足。",
    date: "2026-08-27",
    readTime: "5 分钟",
    comments: "2.2万",
    status: "已反转",
    highlight: false,
    nodes: [
      { time: "08-20 16:00", title: "挂牌消息", detail: "业内爆料某明星选手被战队挂牌，消息一出粉丝一片哗然，评论区吵成一片。", kind: "开始" },
      { time: "08-21 14:00", title: "留队信号", detail: "选手本人发微博晒基地照片，配文「家在这」，被解读为留队信号，反转开始。", kind: "反转" },
      { time: "08-23 20:00", title: "再次生变", detail: "新东家官微删博又秒发，转会传闻卷土重来，剧情再度反转。", kind: "高潮" },
      { time: "08-27 11:00", title: "尘埃落定", detail: "官方正式官宣选手转会去向，各方送上祝福，这场「转会连续剧」终于落幕。", kind: "尾声" },
    ],
  },
];

export const faqs: Faq[] = [
  { q: "吃瓜时间线到底是什么？", a: "吃瓜时间线是一个专注于热点事件梳理的资讯平台。我们会把每起正在发酵或已经尘埃落定的热门事件，从爆发、发酵、高潮到反转的关键节点，按时间顺序整理成一条清晰完整的时间线，让你花几分钟就能补全事件始末。" },
  { q: "时间线里的信息从哪里来？", a: "我们的内容以各事件的公开报道、当事方声明和权威媒体信息为基础进行二次梳理。每条时间线都会尽量标注关键节点的时间与信息来源倾向，帮助你判断哪些是已证实的进展、哪些仍是网传猜测。" },
  { q: "为什么有些事件标着「发酵中」？", a: "标「发酵中」的事件意味着各方说法尚未完全一致、仍有新进展在不断出现。我们会持续跟踪并更新时间线，一旦事件出现实质反转或官方定论，就会及时补充新节点。" },
  { q: "事件出现反转后，之前的内容会删掉吗？", a: "不会。我们认为「反转」本身就是完整事件脉络的重要一环。我们会在原时间线上新增反转与最新进展节点，并保留此前各阶段的内容，方便你看到事情的完整演变过程，而不是只看到结果。" },
  { q: "如何提交一个我正在关注的事件？", a: "欢迎通过页尾的「提交线索」邮箱告诉我们你关注的热点。我们会在核实公开信息后，评估是否将其纳入梳理范围，并在上线后第一时间通知你。" },
  { q: "平台的更新频率是多久？", a: "热榜信息每天多次刷新；正在发酵的事件通常每 2-4 小时更新一次关键节点；已完结事件则会固化为可长期查阅的完整档案。你还可以订阅我们的邮件提醒，第一时间收到重要进展。" },
];